import { useAuth } from '@/contexts/AuthContext';
import { WelcomeGreeting } from '@/components/features/home/WelcomeGreeting';
import { LearningInterface } from '@/components/features/home/LearningInterface';
import { useFirstTimeUser } from '@/hooks/useDataProvider';

export function HomePage() {
  const { user } = useAuth();

  const userName =
    user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'Student';

  // Mock user ID for demonstration - in real app this would come from auth
  const userId = user?.id || 'user1';

  // Determine welcome message based on user's lesson history.
  //
  // Via the hook rather than calling the fixture directly: a top-level
  // `import { isFirstTimeUser } from '@/data/demo/mockLearningData'` here put
  // the whole demo dataset in the entry chunk for every production user, since
  // `/` is an eagerly-imported route. The hook loads it behind a dynamic
  // import inside its queryFn, so the chunk is only fetched in mock/empty mode.
  const { isFirstTime } = useFirstTimeUser(userId);
  const welcomeMessage = isFirstTime
    ? 'What would you like to explore today?'
    : 'Ready to continue your learning journey?';

  // The outer div owns the page's scroll. `AppLayout`'s `<main>` is
  // `h-full overflow-hidden` and leaves scrolling to each page (Wellbeing and
  // the dev errors page do the same); without this, anything below the fold
  // was clipped with no way to reach it - 37px at 390x844, the bottom of the
  // topic chips, and far more on a shorter phone or a short desktop window.
  return (
    <div className='h-full overflow-y-auto'>
      <div className='mx-auto max-w-7xl px-4 py-5 sm:px-6 sm:py-8 lg:px-8'>
        {/* The greeting carries the SAME `max-w-4xl` measure as the composer and
         * the topic chips below it. Previously the heading sat in the outer
         * `max-w-7xl` and started at x=112 while everything under it started at
         * x=272 — a 160px orphan, and the single most damaging thing on the page:
         * no amount of surface or colour work reads as considered while the
         * headline and the body are on different left edges.
         *
         * There is deliberately no eyebrow above the greeting. A mono
         * "Ask anything" line sat here and duplicated the composer's own
         * invitation one element below it, so the page opened by asking twice. */}
        <div className='mb-5 sm:mb-8'>
          <WelcomeGreeting userName={userName} message={welcomeMessage} />
        </div>

        {/* Learning Interface */}
        <LearningInterface />
      </div>
    </div>
  );
}
